import React from 'react'
import { Button, Popconfirm } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch } from 'src/app/hooks'
import { FleetDataType } from 'src/core/models'
import { DeleteOutlined } from '@ant-design/icons'
import { deleteFleet } from 'src/features/manage-cabify-process/actions'

const FleetListDeleteBtn: React.FC<{ fleet: FleetDataType }> = ({ fleet }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return  <>
    <Popconfirm
      okText={t('general.Yes')}
      cancelText={t('general.Cancel')}
      title={t('general.SureDelete')}
      placement={'left'}
      onConfirm={() => dispatch(deleteFleet(fleet.id))}
    >
      <Button
        danger
        type='ghost'
        size='middle'
        shape='circle'
        icon={ <DeleteOutlined /> }
        className={`radius-100 ml-2`}
      />
    </Popconfirm>
  </>
}

export default FleetListDeleteBtn
